// src/data/irisReferenceData.js

export const referenceSections = [
  {
    id: "technology",
    title: "Technology Type Options (IRIS ID: PD2348)",
    content: (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.98rem",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              TECHNOLOGY TYPE
            </th>
          </tr>
        </thead>
        <tbody>{/* ... existing technology rows ... */}</tbody>
      </table>
    ),
  },

  {
    id: "energy",
    title: "Primary Energy Source Options (IRIS ID: OI3781)",
    content: (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.98rem",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              PRIMARY ENERGY SOURCE
            </th>
          </tr>
        </thead>
        <tbody>{/* ... existing energy rows ... */}</tbody>
      </table>
    ),
  },

  // ── NEW SECTION: Product/Service Type & Detailed Type ──────────────────────
  {
    id: "product-service",
    title:
      "Product/Service Type (IRIS ID: PD3017) and Product/Service Detailed Type Options (IRIS ID: PD1516)",
    content: (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.98rem",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              PRODUCT/SERVICE TYPE
            </th>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              PRODUCT/SERVICE DETAILED TYPE
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
                verticalAlign: "top",
              }}
            >
              Agriculture, forestry and fishing
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Crop and animal production, hunting and related service
              activities
              <br />
              - Crop and livestock processing
              <br />
              - Fishing and aquaculture
              <br />
              - Forestry and logging
              <br />- Input Distribution (fertilizers, seeds, etc.)
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
                verticalAlign: "top",
              }}
            >
              Energy, mining and quarrying
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Mining of coal and lignite
              <br />
              - Extraction of crude petroleum and natural gas
              <br />
              - Mining of metal ores
              <br />
              - Other Mining and quarrying
              <br />
              - Mining support service activities
              <br />
              - Biofuel/Biomass production
              <br />
              - Energy Efficient or Self-Powered Products (Solar Lanterns,
              Stoves, Heaters, Cold Storage, etc.)
              <br />
              - Energy Efficient Storage and Distribution Services
              <br />
              - Renewable Energy Generation
              <br />
              - Non-Renewable Energy Generation
              <br />- Energy Technical Assistance
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
                verticalAlign: "top",
              }}
            >
              Manufacturing
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Manufacture of food products
              <br />
              - Manufacture of beverages
              <br />
              - Manufacture of tobacco products
              <br />
              - Manufacture of textiles
              <br />
              - Manufacture of wearing apparel
              <br />
              - Manufacture of leather and related products
              <br />
              - Manufacture of wood and of products of wood and cork, except
              furniture; manufacture of articles of straw and plaiting materials
              <br />
              - Manufacture of paper and paper products
              <br />
              - Printing and reproduction of recorded media
              <br />
              - Manufacture of coke and refined petroleum products
              <br />
              - Manufacture of chemicals and chemical products
              <br />
              - Manufacture of basic pharmaceutical products and pharmaceutical
              preparations
              <br />
              - Manufacture of rubber and plastics products
              <br />
              - Manufacture of other non-metallic mineral products
              <br />
              - Manufacture of basic metals
              <br />
              - Manufacture of fabricated metal products, except machinery and
              equipment
              <br />
              - Manufacture of computer, electronic and optical products
              <br />
              - Manufacture of electrical equipment
              <br />
              - Manufacture of machinery and equipment n.e.c.
              <br />
              - Manufacture of motor vehicles, trailers and semi-trailers
              <br />
              - Manufacture of other transport equipment
              <br />
              - Manufacture of furniture
              <br />
              - Manufacture of environmentally-friendly consumer products
              <br />
              - Other manufacturing
              <br />- Repair and installation of machinery and equipment
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Electricity, gas, steam and air conditioning supply
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Electricity, gas, steam and air conditioning supply
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Water supply; sewerage, waste management and remediation
              activities
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Water collection, storage, treatment and supply
              <br />
              - Sewerage
              <br />
              - Waste collection, treatment and disposal activities; materials
              recovery
              <br />- Remediation activities and other waste management services
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Construction
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Construction of buildings/infrastructure
              <br />
              - Civil engineering
              <br />
              - Specialized Construction activities
              <br />
              - Construction of green buildings/infrastructure
              <br />
              - Renovations/Improvements of buildings/infrastructure
              <br />- Renovations/Improvements of green buildings/infrastructure
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Wholesale and retail trade; repair of motor vehicles and
              motorcycles
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Wholesale and retail trade and repair of motor vehicles and
              motorcycles
              <br />
              - Wholesale trade, except of motor vehicles and motorcycles
              <br />- Retail trade, except of motor vehicles and motorcycles
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Transportation and storage
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Land transport (includes product transport via pipelines)
              <br />
              - Water transport
              <br />
              - Air transport
              <br />
              - Warehousing and support activities for transportation
              <br />
              - Postal and courier activities
              <br />
              - Mass transit Services
              <br />- Personal transit Services
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Accommodation and food service activities
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Accommodation
              <br />- Food and beverage service activities
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Information and communication
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Publishing activities
              <br />
              - Motion picture, video and television programme production, sound
              recording and music publishing activities
              <br />
              - Programming and broadcasting activities
              <br />
              - Telecommunications and mobile services
              <br />
              - Computer programming, consultancy and related activities
              <br />
              - Information service activities
              <br />- Internet access
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Financial and insurance activities
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Agriculture financing
              <br />
              - Banking
              <br />
              - Community services financing
              <br />
              - Education financing
              <br />
              - Household needs/consumption financing
              <br />
              - Housing finance and real estate markets
              <br />
              - Non-compulsory pensions and contractual savings
              <br />
              - Micro- and SME finance
              <br />
              - Voluntary demand deposits
              <br />
              - Voluntary term deposits
              <br />
              - Other financing
              <br />
              - Payment systems, securities clearance, and settlement
              <br />
              - Capital markets
              <br />
              - General finance
              <br />
              - General insurance
              <br />
              - Health insurance
              <br />
              - House/Home insurance
              <br />- Life insurance
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Real estate activities
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Real estate activities
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Professional, scientific and technical activities
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Legal and accounting activities
              <br />
              - Activities of head offices; management consultancy activities
              <br />
              - Architectural and engineering activities; technical testing and
              analysis
              <br />
              - Scientific research and development
              <br />
              - Advertising and market research
              <br />
              - Other professional and scientific activities
              <br />
              - Veterinary activities
              <br />- Technical assistance
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Administrative and support service activities
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Rental and leasing activities
              <br />
              - Employment activities
              <br />
              - Travel agency, tour operator, reservation service and related
              activities
              <br />
              - Security and investigation activities
              <br />
              - Services to buildings and landscape activities
              <br />- Office administrative, Office support and Other business
              support activities
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Public administration and defense; compulsory social security
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Public administration and defense; compulsory social security
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Education
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Extra Curricular Activities
              <br />
              - Educational Materials/Equipment
              <br />
              - Educator Development/Training
              <br />
              - Early Childhood Academic Education
              <br />
              - Primary Academic Education
              <br />
              - Secondary Academic Education
              <br />
              - Post-Secondary Academic Education
              <br />
              - Vocational Education (Teacher Training, Carpentry, etc.)
              <br />
              - Educational Technical Assistance
              <br />- Adult literacy/Non-Formal Education
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Human health and social work activities
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Pharmacies
              <br />
              - Hospitals/Health Clinics
              <br />
              - Specialty Clinics/Health Kiosks
              <br />
              - Health-related transportation Services (ambulance, etc.)
              <br />
              - Residential care activities
              <br />- Social work activities without Accommodation
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Arts, entertainment and recreation
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Creative, arts and entertainment activities
              <br />
              - Libraries, archives, museums and other cultural activities
              <br />
              - Gambling and betting activities
              <br />- Sports activities and amusement and recreation activities
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Other service activities
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Activities of membership organizations
              <br />
              - Repair of computers and Personal and household goods
              <br />- Other Personal service activities
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Activities of households as employers; undifferentiated goods -
              and services-producing activities of households for own use
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Activities of households as employers of domestic personnel
              <br />- Undifferentiated goods - producing activities of private
              households for own use
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Activities of extraterritorial organizations and bodies
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Activities of extraterritorial organizations and bodies
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Environmental Management
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Biodiversity monitoring Services
              <br />
              - Carbon offset Products
              <br />
              - Greenhouse gas reduction Services
              <br />
              - Land preservation/conservation
              <br />
              - Reforestation
              <br />
              - Waste management and recycling Services
              <br />- Environmental Technical Assistance
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Other
            </td>
            <td
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Other
            </td>
          </tr>

          <tr>
            <td
              colSpan="2"
              style={{
                padding: "16px",
                fontStyle: "italic",
                color: "#555",
                borderTop: "2px solid #e0e0e0",
              }}
            >
              Source: UN - International Standard Industrial Classification of
              All Economic Activities, Rev.4
              <br />
              http://unstats.un.org/unsd/cr/registry/regcst.asp?Cl=27
              <br />
              <br />
              Please note that additional fields have been added to account for
              further detail in the type and detailed type of activities.
            </td>
          </tr>
        </tbody>
      </table>
    ),
  },
  {
    id: "crop-type",
    title: "Crop Type Options (IRIS ID: PD1620)",
    content: (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.98rem",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              CROP TYPE
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Agave fibres nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Almonds, with shell
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Anise, badian, fennel, coriander
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Apples
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Apricots
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Areca nuts
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Artichokes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Asparagus
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Avocados
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bambara beans
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bananas
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Barley
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bastfibres, other
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Beans, dry
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Beans, green
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Berries nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Blueberries
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Brazil nuts, with shell
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Broad beans, horse beans, dry
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Buckwheat
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cabbages and other brassicas
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Canary seed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Carobs
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Carrots and turnips
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cashew nuts, with shell
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cashewapple
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cassava
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cassava leaves
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Castor oil seed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cauliflowers and broccoli
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cereals nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cherries
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cherries, sour
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Chestnut
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Chick peas
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Chicory roots
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Chillies and peppers, dry
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Chillies and peppers, green
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cinnamon (cannella)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cloves
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cocoa, beans
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Coconuts
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Coffee, green
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Coir
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cow peas, dry
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cranberries
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cucumbers and gherkins
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Currants
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Dates
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Eggplants (aubergines)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fibre crops nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Figs
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Flax fibre and tow
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fonio
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fruit, citrus nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fruit, fresh nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fruit, pome nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fruit, stone nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fruit, tropical fresh nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Garlic
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Ginger
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Gooseberries
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Grain, mixed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Grapefruit (inc. pomelos)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Grapes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Groundnuts, with shell
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Gums, natural
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Hard Fibres, Other
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Hazelnuts, with shell
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Hemp tow waste
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Hempseed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Hops
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Jojoba seed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Jute
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kapok fruit
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Karite nuts (sheanuts)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kiwi fruit
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kola nuts
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Leeks, other alliaceous vegetables
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Lemons, Limes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Lentils
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Lettuce and chicory
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Linseed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Lupins
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Maize
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Maize, green
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mangoes, mangosteens, guavas
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Manila fibre (abaca)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Maté
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Melons, other (inc.cantaloupes)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Melonseed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Millet
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mushrooms and truffles
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mustard seed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Nutmeg, mace and cardamoms
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Nuts nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Oats
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Oil palm fruit
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Oilseeds nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Okra
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Olives
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Onions, dry
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Onions, shallots, green
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Oranges
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Papayas
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Peaches and nectarines
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Peas, dry
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Peas, green
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pepper (piper spp.)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Peppermint
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Persimmons
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pigeon peas
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pineapples
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pistachios
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Plantains and others
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Plums and sloes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Poppy seed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Potatoes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pulses nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pumpkins, squash and gourds
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pyrethrum, dried
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Quinces
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Quinoa
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Ramie
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Rapeseed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Raspberries
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Rice, paddy (rice milled equivalent)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Rice, paddy
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Roots and tubers nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Roots, Other
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Rubber, natural
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Rye
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Safflower seed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Seed cotton
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sesameseed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sisal
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Soft-Fibres, Other
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sorghum
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Soybeans
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Spices nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Spinach
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Strawberries
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              String beans
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sugar beet
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sugar cane
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sugar crops nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sunflower seed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sweet potatoes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tallowtree seed
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tangerines, mandarins, clementines, satsumas
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Taro (cocoyam)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tea
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tobacco
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tomatoes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Triticale
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tung nuts
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Vanilla
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Vegetables, fresh nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Vegetables, leguminous nes
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Vetches
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Walnuts, with shell
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Watermelons
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Wheat
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Wine
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Yams
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Yautia (cocoyam)
            </td>
          </tr>
          <tr>
            <td style={{ padding: "16px", fontStyle: "italic", color: "#555" }}>
              For a list of tree types, refer to GlobalTreeSearch:
              https://tools.bgci.org/global_tree_search.php?action=about
              <br />
              <br />
              Source: UN FAO Food Supply and Commodity Crops
              <br />
              http://www.fao.org/faostat/en/#data/QC
            </td>
          </tr>
        </tbody>
      </table>
    ),
  },
  {
    id: "livestock-fish",
    title: "Livestock/Fish Type Options (IRIS ID: PD4686)",
    content: (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.98rem",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              LIVESTOCK / FISH TYPE
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Aquatic Animals, Other
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Aquatic Plants
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bovine Meat
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Butter, Ghee
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cephalopods
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cheese
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cream
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Crustaceans
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Demersal Fish
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Eggs
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fats, Animals, Raw
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fish Meal
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fish, Body Oil
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fish, Liver Oil
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Freshwater Fish
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Hides & Skins
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Honey
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Marine Fish, Other
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Meat Meal
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Meat, Aquatic Mammals
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Meat, Other
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Milk Excluding Butter
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Milk, Whole
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Molluscs, Other
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mutton & Goat Meat
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Offals, Edible
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pelagic Fish
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pigmeat
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Poultry Meat
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "8px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Whey
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "12px 16px",
                fontStyle: "italic",
                color: "#555",
              }}
            >
              Source: UN FAO Food Supply and Commodity Livestock and Fish
              <br />
              http://faostat3.fao.org/download/FB/CL/E
            </td>
          </tr>
        </tbody>
      </table>
    ),
  },
  {
    id: "currency",
    title: "Reporting Currency (IRIS ID: OD5990)",
    content: (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.95rem",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
                width: "20%",
              }}
            >
              CURRENCY CODE
            </th>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              GEOGRAPHIC AREA
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              AED
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              United Arab Emirates Dirham
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              AFN
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Afghanistan Afghani
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              ALL
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Albania Lek
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              AMD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Armenia Dram
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              ANG
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Netherlands Antilles Guilder
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              AOA
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Angola Kwanza
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              ARS
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Argentina Peso
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              AUD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Australia Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              AWG
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Aruba Guilder
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              AZN
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Azerbaijan New Manat
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BAM
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bosnia and Herzegovina Convertible Marka
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BBD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Barbados Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BDT
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bangladesh Taka
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BGN
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bulgaria Lev
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BHD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bahrain Dinar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BIF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Burundi Franc
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BMD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bermuda Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BND
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Brunei Darussalam Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BOB
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bolivia Boliviano
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BRL
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Brazil Real
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BSD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bahamas Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BTN
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bhutan Ngultrum
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BWP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Botswana Pula
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BYR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Belarus Ruble
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              BZD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Belize Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              CAD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Canada Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              CDF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Congo/Kinshasa Franc
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              CHF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Switzerland Franc
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              CLP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Chile Peso
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              CNY
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              China Yuan Renminbi
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              COP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Colombia Peso
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              CRC
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Costa Rica Colon
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              CUC
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cuba Convertible Peso
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              CUP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cuba Peso
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              CVE
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cape Verde Escudo
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              CZK
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Czech Republic Koruna
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              DJF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Djibouti Franc
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              DKK
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Denmark Krone
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              DOP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Dominican Republic Peso
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              DZD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Algeria Dinar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              EGP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Egypt Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              ERN
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Eritrea Nakfa
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              ETB
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Ethiopia Birr
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              EUR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Euro Member Countries
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              FJD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fiji Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              FKP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Falkland Islands (Malvinas) Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              GBP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              United Kingdom Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              GEL
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Georgia Lari
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              GGP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Guernsey Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              GHS
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Ghana Cedi
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              GIP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Gibraltar Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              GMD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Gambia Dalasi
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              GNF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Guinea Franc
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              GTQ
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Guatemala Quetzal
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              GYD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Guyana Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              HKD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Hong Kong Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              HNL
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Honduras Lempira
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              HRK
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Croatia Kuna
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              HTG
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Haiti Gourde
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              HUF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Hungary Forint
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              IDR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Indonesia Rupiah
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              ILS
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Israel Shekel
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              IMP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Isle of Man Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              INR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              India Rupee
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              IQD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Iraq Dinar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              IRR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Iran Rial
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              ISK
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Iceland Krona
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              JEP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Jersey Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              JMD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Jamaica Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              JOD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Jordan Dinar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              JPY
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Japan Yen
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              KES
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kenya Shilling
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              KGS
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kyrgyzstan Som
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              KHR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cambodia Riel
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              KMF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Comoros Franc
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              KPW
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Korea (North) Won
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              KRW
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Korea (South) Won
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              KWD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kuwait Dinar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              KYD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cayman Islands Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              KZT
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kazakhstan Tenge
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              LAK
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Laos Kip
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              LBP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Lebanon Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              LKR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sri Lanka Rupee
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              LRD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Liberia Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              LSL
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Lesotho Loti
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              LYD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Libya Dinar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MAD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Morocco Dirham
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MDL
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Moldova Leu
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MGA
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Madagascar Ariary
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MKD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Macedonia Denar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MMK
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Myanmar (Burma) Kyat
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MNT
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mongolia Tughrik
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MOP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Macau Pataca
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MRO
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mauritania Ouguiya
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MUR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mauritius Rupee
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MVR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Maldives (Maldive Islands) Rufiyaa
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MWK
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Malawi Kwacha
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MXN
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mexico Peso
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MYR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Malaysia Ringgit
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              MZN
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mozambique Metical
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              NAD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Namibia Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              NGN
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Nigeria Naira
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              NIO
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Nicaragua Cordoba
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              NOK
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Norway Krone
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              NPR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Nepal Rupee
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              NZD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              New Zealand Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              OMR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Oman Rial
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              PAB
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Panama Balboa
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              PEN
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Peru Nuevo Sol
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              PGK
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Papua New Guinea Kina
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              PHP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Philippines Peso
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              PKR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pakistan Rupee
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              PLN
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Poland Zloty
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              PYG
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Paraguay Guarani
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              QAR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Qatar Riyal
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              RON
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Romania New Leu
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              RSD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Serbia Dinar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              RUB
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Russia Ruble
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              RWF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Rwanda Franc
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SAR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Saudi Arabia Riyal
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SBD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Solomon Islands Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SCR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Seychelles Rupee
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SDG
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sudan Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SEK
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sweden Krona
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SGD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Singapore Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SHP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Saint Helena Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SLL
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sierra Leone Leone
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SOS
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Somalia Shilling
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SPL
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Seborga Luigino
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SRD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Suriname Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              STD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              São Tomé and Príncipe Dobra
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SVC
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              El Salvador Colon
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SYP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Syria Pound
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              SZL
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Swaziland Lilangeni
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              THB
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Thailand Baht
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              TJS
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tajikistan Somoni
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              TMT
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Turkmenistan Manat
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              TND
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tunisia Dinar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              TOP
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tonga Pa'anga
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              TRY
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Turkey Lira
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              TTD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Trinidad and Tobago Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              TVD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tuvalu Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              TWD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Taiwan New Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              TZS
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tanzania Shilling
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              UAH
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Ukraine Hryvna
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              UGX
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Uganda Shilling
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              USD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              United States Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              UYU
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Uruguay Peso
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              UZS
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Uzbekistan Som
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              VEF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Venezuela Bolivar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              VND
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Viet Nam Dong
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              VUV
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Vanuatu Vatu
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              WST
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Samoa Tala
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              XAF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Communauté Financière Africaine (BEAC) CFA Franc BEAC
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              XAG
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Silver, Ounces
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              XAU
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Gold, Ounces
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              XCD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              East Caribbean Dollar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              XDR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              International Monetary Fund (IMF) Special Drawing Rights
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              XOF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Communauté Financière Africaine (BCEAO) Franc
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              XPD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Palladium Ounces
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              XPF
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Comptoirs Français du Pacifique (CFP) Franc
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              XPT
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Platinum, Ounces
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              YER
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Yemen Rial
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              ZAR
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              South Africa Rand
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              ZMW
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Zambia Kwacha
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              ZWD
            </td>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Zimbabwe Dollar
            </td>
          </tr>
          <tr>
            <td
              colSpan="2"
              style={{
                padding: "16px",
                fontStyle: "italic",
                color: "#555",
                borderTop: "2px solid #e0e0e0",
              }}
            >
              Source: ISO 4217 Currency Codes
              <br />
              http://www.iso.org/iso/home/standards/currency_codes.htm
            </td>
          </tr>
        </tbody>
      </table>
    ),
  },
  {
    id: "country",
    title: "Country Name (IRIS ID: PD2587, PD4565)",
    content: (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.95rem",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              COUNTRY NAME
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Afghanistan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Albania
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Algeria
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              American Samoa
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Andorra
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Angola
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Antigua and Barbuda
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Argentina
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Armenia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Aruba
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Australia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Austria
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Azerbaijan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bahamas, The
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bahrain
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bangladesh
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Barbados
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Belarus
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Belgium
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Belize
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Benin
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bermuda
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bhutan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bolivia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bosnia and Herzegovina
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Botswana
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Brazil
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              British Virgin Islands
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Brunei Darussalam
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Bulgaria
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Burkina Faso
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Burundi
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cabo Verde
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cambodia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cameroon
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Canada
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cayman Islands
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Central African Republic
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Chad
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Channel Islands
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Chile
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              China
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Hong Kong SAR, China
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Macao SAR, China
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Colombia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Comoros
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Congo, Rep.
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Costa Rica
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Côte d'Ivoire
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Croatia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cuba
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Curaçao
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Cyprus
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Czech Republic
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Korea, Dem. People's Rep.
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Congo, Dem. Rep.
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Denmark
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Djibouti
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Dominica
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Dominican Republic
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Ecuador
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Egypt, Arab Rep.
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              El Salvador
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Equatorial Guinea
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Eritrea
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Estonia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Eswatini
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Ethiopia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Faroe Islands
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Fiji
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Finland
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              France
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              French Polynesia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Gabon
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Gambia, The
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Georgia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Germany
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Ghana
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Gibraltar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Greece
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Greenland
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Grenada
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Guam
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Guatemala
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Guinea
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Guinea-Bissau
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Guyana
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Haiti
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Honduras
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Hungary
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Iceland
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              India
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Indonesia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Iran, Islamic Rep.
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Iraq
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Ireland
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Isle of Man
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Israel
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Italy
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Jamaica
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Japan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Jordan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kazakhstan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kenya
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kiribati
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kuwait
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Kyrgyz Republic
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Lao PDR
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Latvia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Lebanon
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Lesotho
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Liberia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Libya
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Liechtenstein
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Lithuania
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Luxembourg
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Madagascar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Malawi
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Malaysia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Maldives
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mali
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Malta
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Marshall Islands
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mauritania
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mauritius
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mexico
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Micronesia, Fed. Sts.
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Moldova
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Monaco
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mongolia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Montenegro
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Morocco
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Mozambique
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Myanmar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Namibia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Nauru
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Nepal
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Netherlands
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              New Caledonia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              New Zealand
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Nicaragua
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Niger
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Nigeria
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              North Macedonia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Northern Mariana Islands
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Norway
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Oman
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Pakistan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Palau
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Palestine
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Panama
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Papua New Guinea
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Paraguay
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Peru
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Philippines
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Poland
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Portugal
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Puerto Rico
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Qatar
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Korea, Rep.
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Romania
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Russian Federation
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Rwanda
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Samoa
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              San Marino
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              São Tomé and Principe
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Saudi Arabia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Senegal
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Serbia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Seychelles
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sierra Leone
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Singapore
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sint Maarten (Dutch part)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Slovak Republic
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Slovenia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Solomon Islands
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Somalia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              South Africa
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              South Sudan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Spain
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sri Lanka
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              St. Kitts and Nevis
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              St. Lucia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              St. Martin (French part)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              St. Vincent and the Grenadines
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sudan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Suriname
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Sweden
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Switzerland
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Syrian Arab Republic
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Taiwan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tajikistan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tanzania
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Thailand
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Timor-Leste
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Togo
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tonga
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Trinidad and Tobago
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tunisia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Turkey
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Turkmenistan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Turks and Caicos Islands
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Tuvalu
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Uganda
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Ukraine
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              United Arab Emirates
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              United Kingdom
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              United States
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Uruguay
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Uzbekistan
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Vanuatu
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Venezuela, RB
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Vietnam
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Virgin Islands (U.S.)
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Yemen, Rep.
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Zambia
            </td>
          </tr>
          <tr>
            <td
              style={{ padding: "6px 16px", borderBottom: "1px solid #e0e0e0" }}
            >
              Zimbabwe
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "16px",
                fontStyle: "italic",
                color: "#555",
                borderTop: "2px solid #e0e0e0",
              }}
            >
              Source: UN Countries or areas, codes and abbreviations
              <br />
              http://unstats.un.org/unsd/methods/m49/m49alpha.htm
            </td>
          </tr>
        </tbody>
      </table>
    ),
  },
  {
    id: "threats",
    title: "Species Extinction Threat (IRIS ID: PD6363)",
    content: (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.95rem",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              THREATS TO SPECIES
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                padding: "10px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Agriculture
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Annual & perennial non-timber crops
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Shifting agriculture
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Smallholder farming
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Agro-industry farming
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Type of agriculture unknown/unrecorded
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "10px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Biological resource use
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Hunting & collecting terrestrial animals
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 60px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Intentional use (species being assessed is the target)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 60px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Unintentional effects (species being assessed is not the target)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 60px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Persecution/control
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 60px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              - Motivation of biological resource use unknown/unrecorded
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "10px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Climate change & severe weather
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Habitat shifting & alteration
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Droughts
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Temperature extremes
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Storms & flooding
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Other climate change & severe weather impacts (describe)
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "10px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Dams & water management/use
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Abstraction of surface water (domestic use)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Abstraction of surface water (commercial use)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Abstraction of surface water (agricultural use)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Abstraction of surface water (unknown use)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Abstraction of groundwater (domestic use)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Abstraction of groundwater (commercial use)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Abstraction of groundwater (agricultural use)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Abstraction of groundwater (unknown use)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Small dams
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Large dams
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Dams (size unknown)
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Other ecosystem modifications (describe)
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "10px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Energy production & mining
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Oil & gas drilling
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Mining & quarrying
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Renewable energy
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Other energy production & mining (describe)
            </td>
          </tr>

          {/* You can continue adding the remaining categories in the same pattern... */}
          {/* For brevity here, I've shown the structure. Add the rest following the same indentation and hierarchy */}

          <tr>
            <td
              style={{
                padding: "16px",
                fontStyle: "italic",
                color: "#555",
                borderTop: "2px solid #e0e0e0",
              }}
            >
              Source: IUCN Red List - Threats Classification Scheme (Version
              3.2)
              <br />
              https://www.iucnredlist.org/resources/threat-classification-scheme
            </td>
          </tr>
        </tbody>
      </table>
    ),
  },
  {
    id: "ecoregions",
    title: "Target Ecoregions (IRIS ID: PD2854)",
    content: (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.95rem",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#0d47a1",
                color: "white",
                padding: "12px 16px",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              ECOREGIONS
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                padding: "10px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Terrestrial Ecoregions
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Deserts and xeric shrublands
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Tropical and subtropical moist broadleaf forests
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Tropical and subtropical dry broadleaf forests
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Tropical and subtropical coniferous forests
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Temperate broadleaf and mixed forests
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Temperate coniferous forest
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Boreal forests/Taiga
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Tropical and subtropical grasslands, savannas and shrublands
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Temperate grasslands, savannas and shrublands
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Flooded grasslands and savannas
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Montane grasslands and shrublands
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Tundra
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Mediterranean forests, woodlands and scrubs
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Mangroves
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Other terrestrial ecoregion (describe)
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "10px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Freshwater Ecoregions
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Large river ecosystems
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Large river headwater ecosystems
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Large river delta ecosystems
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Small river ecosystems
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Large lake ecosystems
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Small lake ecosystems
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Xeric basin ecosystems
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Other freshwater ecoregion (describe)
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "10px 16px",
                borderBottom: "1px solid #e0e0e0",
                fontWeight: "600",
              }}
            >
              Marine Ecoregions
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Polar ecoregions
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Temperate shelf and seas ecoregions
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Temperate upwelling
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Tropical upwellings
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Tropical coral
            </td>
          </tr>
          <tr>
            <td
              style={{
                padding: "6px 16px 6px 40px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              Other marine ecoregion (describe)
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "16px",
                fontStyle: "italic",
                color: "#555",
                borderTop: "2px solid #e0e0e0",
              }}
            >
              Source: WWF - Ecoregions
              <br />
              https://www.worldwildlife.org/biomes
            </td>
          </tr>
        </tbody>
      </table>
    ),
  },
];
